/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState, useCallback, useRef } from 'react';
import { useDispatch, useSelector } from "react-redux";
import * as actions from "../../../store/actions";
import { i18n } from '../../../translate/i18n';
import {
	FormControl, Button, IconButton,
} from '@mui/material';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { FilterList } from "@mui/icons-material";
import CloseIcon from '@mui/icons-material/Close';
import moment from 'moment';
import { DivFormTitle } from './styles';
import Autocomplete from '../../../UI/Autocomplete/Autocomplete';

const ActionFilterModal = (props) => {
	const dispatch = useDispatch();

	const [page] = useState(1);
	const [limit] = useState(30);
	const [orderBy] = useState("name");
	const [order] = useState("asc");

	const [startDate, setStartDate] = useState(null);
	const [endDate, setEndDate] = useState(null);

	const [searchTextUser, setSearchTextUser] = useState('');
	const [usersFormated, setUsersFormated] = useState([]);
	const [selectedUsers, setSelectedUsers] = useState([]);

	const [searchTextSite, setSearchTextSite] = useState('');
	const [sitesFormated, setSitesFormated] = useState([]);
	const [selectedSites, setSelectedSites] = useState([]);

	const [searchTextEquipment, setSearchTextEquipment] = useState('');
	const [equipmentsFormated, setEquipmentsFormated] = useState([]);
	const [selectedEquipments, setSelectedEquipments] = useState([]);

	const [searchTextPlace, setSearchTextPlace] = useState('');
	const [placesFormated, setPlacesFormated] = useState([]);
	const [selectedPlaces, setSelectedPlaces] = useState([]);

	const [searchTextArea, setSearchTextArea] = useState('');
	const [areasFormated, setAreasFormated] = useState([]);
	const [selectedAreas, setSelectedAreas] = useState([]);

	const [searchTextCompanies, setSearchTextCompanies] = useState('');
	const [companiesFormated, setCompaniesFormated] = useState([]);
	const [selectedCompanies, setSelectedCompanies] = useState([]);

	const [searchTextStatus, setSearchTextStatus] = useState('');
	const [selectedStatus, setSelectedStatus] = useState([]);

	const [status] = useState([{
		value: 'progress',
		label: i18n.t('statusActionModalFilter.progress')
	},
	{
		value: 'overdue',
		label: i18n.t('statusActionModalFilter.overdue')
	},
	{
		value: 'canceled',
		label: i18n.t('statusActionModalFilter.canceled')
	},
	{
		value: 'completed',
		label: i18n.t('statusActionModalFilter.completed')
	}]);

	const fetchUsers = useCallback(
		() => dispatch(actions.fetchUsers(page, limit, searchTextUser, order, orderBy)),
		[page, limit, searchTextUser, order, orderBy]
	);

	const fetchSites = useCallback(
		() => dispatch(actions.fetchSites(page, limit, searchTextSite, order, orderBy)),
		[page, limit, searchTextSite, order, orderBy]
	);

	const fetchEquipments = useCallback(
		() => dispatch(actions.fetchEquipmentModels(page, limit, searchTextEquipment, order, orderBy)),
		[page, limit, searchTextEquipment, order, orderBy]
	);

	const fetchPlaces = useCallback(
		() => dispatch(actions.fetchPlacesLeafs(selectedSites)),
		[selectedSites]
	);

	const fetchAreas = useCallback(
		() => dispatch(actions.fetchAreas(page, limit, searchTextArea, order, orderBy)),
		[page, limit, searchTextArea, order, orderBy]
	);

	const fetchCompanies = useCallback(
		() => dispatch(actions.actionsFetchCompaniesForFilters(page, limit, searchTextCompanies, order, orderBy)),
		[page, limit, searchTextCompanies, order, orderBy]
	);

	const users = useSelector(state => state.users.users);
	const sites = useSelector(state => state.sites.sites);	
	const equipments = useSelector(state => state.equipmentModels.equipmentModels);
	const places = useSelector(state => state.places.placesLeafs);
	const areas = useSelector(state => state.areas.areas);
	const companies = useSelector(state => state.actions.companiesForFilters);

	const filteredSites = useSelector(state => state.sites.selectedSitesPlaces);
	const filteredUsers = useSelector(state => state.actions.filteredUsers);
	const filteredEquipments = useSelector(state => state.actions.filteredEquipments);
	const filteredPlaces = useSelector(state => state.actions.filteredPlaces);
	const filteredAreas = useSelector(state => state.actions.filteredAreas);
	const filteredStatus = useSelector(state => state.actions.filteredStatus);
	const filteredCompanies = useSelector(state => state.actions.filteredCompanies);
	const filteredStartDate = useSelector(state => state.actions.startDate);
	const filteredEndDate = useSelector(state => state.actions.endDate);

	const loadingUsers = useSelector(state => state.users.loading);
	const loadingSites = useSelector(state => state.sites.loading);
	const loadingEquipments = useSelector(state => state.equipmentModels.loading);
	const loadingPlaces = useSelector(state => state.places.loading);
	const loadingAreas = useSelector(state => state.areas.loading);
	const loadingCompanies =  useSelector(state => state.actions.loadingCompanies);

	useEffect(() => {
		handleInputChangeSites(filteredSites);
		handleInputChangeUsers(filteredUsers);
		handleInputChangeEquipments(filteredEquipments);
		handleInputChangePlaces(filteredPlaces);
		handleInputChangeAreas(filteredAreas);
		handleInputChangeStatus(filteredStatus);
		handleInputChangeCompanies(filteredCompanies)
		setStartDate(filteredStartDate ? filteredStartDate : null);
		setEndDate(filteredEndDate ? filteredEndDate : null);
	}, []);

	useEffect(() => {
		fetchUsers(limit, searchTextUser, order, orderBy);
	}, [searchTextUser]);

	useEffect(() => {
		fetchSites(limit, searchTextSite, order, orderBy);
	}, [searchTextSite]);	

	useEffect(() => {
		fetchEquipments(limit, searchTextEquipment, order, orderBy);
	}, [searchTextEquipment]);

	useEffect(() => {
		fetchPlaces(selectedSites);
	}, [selectedSites]);

	useEffect(() => {
		fetchAreas(limit, searchTextArea, order, orderBy);
	}, [searchTextArea]);

	useEffect(() => {
		fetchCompanies();
	}, [searchTextCompanies])

	useEffect(() => {
		const dataFromRedux = users
		let returnArray = []
		dataFromRedux.rows.map(dt => returnArray.push({ value: dt._id, label: dt.name }))
		setUsersFormated(returnArray)
	}, [users])

	useEffect(() => {
		const dataFromRedux = sites
		let returnArray = []
		dataFromRedux.rows.map(dt => returnArray.push({ value: dt._id, label: dt.name, ...dt }))
		setSitesFormated(returnArray)
	}, [sites])

	useEffect(() => {
		const dataFromRedux = equipments
		let returnArray = []
		dataFromRedux.rows.map(dt => returnArray.push({ value: dt._id, label: dt.name }))
		setEquipmentsFormated(returnArray)
	}, [equipments])

	useEffect(() => {
		const dataFromRedux = places
		let returnArray = []
		dataFromRedux.rows.map(dt => returnArray.push({ value: dt._id, label: dt.path }))
		setPlacesFormated(returnArray)
	}, [places])

	useEffect(() => {
		const dataFromRedux = areas
		let returnArray = []
		dataFromRedux.rows.map(dt => returnArray.push({ value: dt._id, label: dt.name }))
		setAreasFormated(returnArray)
	}, [areas])

	useEffect(() => {
		setCompaniesFormated(
			companies.map(companie => ({ value: companie._id, label: companie.name }))
		)
	}, [companies])

	const handleInputChangeSelectorUsers = (text) => {
		setSearchTextUser(text);
	}

	const handleInputChangeSelectorSites = (text) => {
		setSearchTextSite(text);
	}

	const handleInputChangeSelectorEquipments = (text) => {
		setSearchTextEquipment(text);
	}

	const handleInputChangeSelectorPlaces = (text) => {
		setSearchTextPlace(text);
	}

	const handleInputChangeSelectorStatus = (text) => {
		setSearchTextStatus(text);
	}
	
	const handleInputChangeSelectorAreas = (text) => {
		setSearchTextArea(text);
	}

	const handleInputChangeUsers = selected => {
		setSelectedUsers(selected);
	}

	const handleInputChangeSelectorCompanies = (text) => {
		setSearchTextCompanies(text);
	}

	const handleInputChangeCompanies = selected => {
		setSelectedCompanies(selected);
	}

	const handleInputChangeSites = selected => {
		if(selected) {
			const dataFromRedux = selected
			let returnArray = []
			dataFromRedux.map(dt => returnArray.push({ value: dt._id, label: dt.name, ...dt }))
			setSelectedSites(returnArray);
		} else {
			setSelectedSites([]);
		}
	}

	const handleInputChangeEquipments = selected => {
		setSelectedEquipments(selected);
	}

	const handleInputChangePlaces = selected => {
		setSelectedPlaces(selected);
	}

	const handleInputChangeStatus = selected => {
		setSelectedStatus(selected);
	}

	const handleInputChangeAreas = selected => {
		setSelectedAreas(selected);
	}

	const handleClickFilter = () => {
		dispatch(actions.setSitePlaces(selectedSites));
		dispatch(actions.filterActionUsers(selectedUsers));
		dispatch(actions.filterActionEquipments(selectedEquipments));
		dispatch(actions.filterActionPlaces(selectedPlaces));
		dispatch(actions.filterActionAreas(selectedAreas));
		dispatch(actions.filterActionStatus(selectedStatus));
		dispatch(actions.filterActionStartDate(startDate));
		dispatch(actions.filterActionEndDate(endDate));
		dispatch(actions.actionsfilterCompanies(selectedCompanies));
		props.closeModal();
	}

	const handleClickClearFilters = () => {
		setSelectedUsers([])
		setSelectedEquipments([])
		setSelectedPlaces([])
		setSelectedAreas([])
		setSelectedStatus([])
		setSelectedCompanies([]);
		setStartDate(null)
		setEndDate(null)
	}

	const verifyStartDateRange = () => {
		if(moment(endDate) < moment(startDate)) {
			setStartDate(endDate)
		}
	}
	
	return (
        <div style={styles.container}>			
			<DivFormTitle style={styles.headerContainer}>
				<div style={{ display: 'flex', alignItems: 'center', fontSize: '1.25rem' }}>
					<FilterList style={{ marginRight: '1rem' }} />
					{i18n.t('filterListActionModalFilter.filter')}
					{((selectedUsers && selectedUsers.length > 0)
					|| (selectedEquipments && selectedEquipments.length > 0)
					|| (selectedPlaces && selectedPlaces.length > 0)
					|| (selectedAreas && selectedAreas.length > 0)
					|| (selectedStatus && selectedStatus.length > 0)
					|| (startDate || endDate))
					&& <div style={styles.clearFilter} onClick={handleClickClearFilters}>{i18n.t('filterListActionModalFilter.clearFilter')}</div>}
				</div>
				<IconButton onClick={props.closeModal} color='inherit' size="large">
					<CloseIcon />
				</IconButton>
			</DivFormTitle>
			<div style={styles.bodyContainer}>
				<FormControl variant="standard" fullWidth margin='normal'>
					<Autocomplete
						loading={loadingSites} //sent to isLoading
						label={i18n.t('autocompleteActionModalFilter.sites')}
						data={sitesFormated} // sent to options
						onSelectValue={handleInputChangeSites} // sent to onChange
						valueSelected={selectedSites} // sent to value
						newSearchText={handleInputChangeSelectorSites}
						isMulti
					/>
				</FormControl>
				<FormControl variant="standard" fullWidth margin='normal'>
					<Autocomplete
						loading={loadingUsers} //sent to isLoading
						label={i18n.t('autocompleteActionModalFilter.users')}
						data={usersFormated} // sent to options
						onSelectValue={handleInputChangeUsers} // sent to onChange
						valueSelected={selectedUsers} // sent to value
						newSearchText={handleInputChangeSelectorUsers}
						isMulti
					/>
				</FormControl>
				<FormControl variant="standard" fullWidth margin='normal'>
					<Autocomplete
						loading={loadingEquipments}
						label={i18n.t('autocompleteActionModalFilter.equipments')}
						data={equipmentsFormated}
						onSelectValue={handleInputChangeEquipments}
						valueSelected={selectedEquipments}
						newSearchText={handleInputChangeSelectorEquipments}
						isMulti
					/>
				</FormControl>
				<FormControl variant="standard" fullWidth margin='normal'>
          <Autocomplete
            loading={loadingCompanies}
            label={i18n.t('autocompleteModalFilterEquip.company')}
            data={companiesFormated}
            onSelectValue={handleInputChangeCompanies}
            valueSelected={selectedCompanies}
            newSearchText={handleInputChangeSelectorCompanies}
            id="company"
            isMulti
          />
        </FormControl>
				<FormControl variant="standard" fullWidth margin='normal'>
					<Autocomplete
						loading={loadingPlaces}
						label={i18n.t('autocompleteActionModalFilter.place')}
						data={placesFormated}
						onSelectValue={handleInputChangePlaces}
						valueSelected={selectedPlaces}
						newSearchText={handleInputChangeSelectorPlaces}
						isMulti
					/>
				</FormControl>
				<FormControl variant="standard" fullWidth margin='normal'>
					<Autocomplete
						loading={loadingAreas} //sent to isLoading
						label={i18n.t('autocompleteActionModalFilter.areas')}
						data={areasFormated} // sent to options
						onSelectValue={handleInputChangeAreas} // sent to onChange
						valueSelected={selectedAreas} // sent to value
						newSearchText={handleInputChangeSelectorAreas}
						isMulti
					/>
				</FormControl>
				<FormControl variant="standard" fullWidth margin='normal'>
					<Autocomplete
						label={i18n.t('autocompleteActionModalFilter.status')}
						data={status}
						onSelectValue={handleInputChangeStatus}
						valueSelected={selectedStatus}
						newSearchText={handleInputChangeSelectorStatus}
						isMulti
					/>
				</FormControl>
				<FormControl variant="standard" fullWidth margin='normal'>
					<DatePicker
						label={i18n.t('keyboardDatePickerActionModalFilter.from')}
						margin='normal'
						value={startDate && new Date(startDate)}
						onChange={date => setStartDate(date ?  date : null)}
						format="dd/MM/yyyy"
						slotProps={{ textField: { variant: 'standard', } }}
						/>
				</FormControl>
				<FormControl variant="standard" fullWidth margin='normal'>
					<DatePicker
						label={i18n.t('keyboardDatePickerActionModalFilter.to')}
						margin='normal'
						value={endDate && new Date(endDate)}
						onChange={date => setEndDate(date ?  date : null)}
						onBlurCapture={verifyStartDateRange}
						format="dd/MM/yyyy"
						slotProps={{ textField: { variant: 'standard', } }}
						/>
				</FormControl>
			</div>
			<div style={styles.footerContainer}>
				<div
					onClick={props.closeModal}
					style={styles.buttonCancel}
				>
					{i18n.t('divActionModalFilter.buttonCancel')}
				</div>
				<Button
					variant='contained'
					color='primary'
					onClick={handleClickFilter}
					style={styles.button}
				>
					{i18n.t('divActionModalFilter.button')}
				</Button>
			</div>
		</div>
    );
}

const styles = {
	container: {
		width: '40rem',
		height: '100%'
	},
	headerContainer: {
		height: '5rem',
		padding: '0 1rem 0 2rem',
		backgroundColor: 'green',
		color: '#fff',
	},
	bodyContainer: {
		height: 'calc(100% - 10rem)',
		padding: '1rem 2rem',
		overflowY: 'auto',
		borderTop: '1px solid #ccc',
		borderBottom: '1px solid #ccc',
	},
	chip: {
		display: 'flex',
		alignItems: 'center',
		backgroundColor: '#C5D1E3',
		margin: '0.5rem 0',
		borderRadius: 10,
		padding: '0.3rem 1rem',
		justifyContent: 'space-between'
	},
	footerContainer: {
		height: '5rem',
		padding: '0 2rem',
		display: 'flex',
		justifyContent: 'center',
		alignItems: 'center',
	},
	button: {
		flex: 1,
		backgroundColor: 'green',
		borderRadius: '2rem',
		padding: '0.5rem 1.5rem',
		// width: '100%',
	},
	buttonCancel: {
		flex: 1,
		cursor: 'pointer',
		color: 'grey',
		alignItems: 'center',
		textAlign: 'center',
	},
	clearFilter: {
		fontSize: '1rem', 
		marginLeft: '2rem', 
		color: '#fff', 
		cursor: 'pointer', 
		textDecoration: 'underline' 
	}
}


export default ActionFilterModal;

